import { useState } from 'react'
import { MobileIcon, Nav, NavLinks, NavMenu, NavItem } from './Nav.elements'

const Navbar = () => {
  const [click, setClick] = useState(false)

  const handleClick = () => {
    setClick(!click)
  }

  return (
    <Nav>
      <MobileIcon onClick={handleClick}>
        {!click ? (
          <i className="fa fa-bars" aria-hidden="true"></i>
        ) : (
          <i className="fa fa-times" aria-hidden="true"></i>
        )}
      </MobileIcon>
      <NavMenu onClick={handleClick} click={click}>
        <NavItem>
          <NavLinks href="#mywork-section">MY WORK</NavLinks>
        </NavItem>

        <NavItem>
          <NavLinks href="#connect-section">CONNECT WITH ME</NavLinks>
        </NavItem>
      </NavMenu>
    </Nav>
  )
}

export default Navbar
